var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2155 10.8889H3.65994V5.44444H5.2155V10.8889ZM8.32661 10.8889H6.77105V3.11111H8.32661V10.8889ZM11.4377 10.8889H9.88216V7.77778H11.4377V10.8889ZM12.9933 12.4444H2.10438V1.55556H12.9933V12.5222V12.4444ZM12.9933 0H2.10438C1.24883 0 0.548828 0.7 0.548828 1.55556V12.4444C0.548828 13.3 1.24883 14 2.10438 14H12.9933C13.8488 14 14.5488 13.3 14.5488 12.4444V1.55556C14.5488 0.7 13.8488 0 12.9933 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBench);
export default __webpack_public_path__ + "static/media/bench.d7c1c366.svg";
export { ForwardRef as ReactComponent };